import React from 'react';

export default function TextFieldOverrides() {
  return {
    MuiTextField: {
      defaultProps: {
        onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => {
          const input = e.target as HTMLInputElement;
          const type = input.type;

          if (type === "tel") {
            const telAllowed = /^[0-9+\-() ]$/;
            if (!telAllowed.test(e.key) && e.key.length === 1) {
              e.preventDefault();
            }
            return;
          }

          const textAllowed = /^[A-Za-z0-9@._\- ]$/;
          if (!textAllowed.test(e.key) && e.key.length === 1) {
            e.preventDefault();
          }
        },
      },
      styleOverrides: {
        root: {
          "& .MuiInputLabel-root.Mui-disabled": { color: "#868B8F" },
          '& .MuiInputBase-input.Mui-disabled': { WebkitTextFillColor: '#868B8F !important', },
          "& .MuiInputLabel-asterisk": { display: "none" },
          "& .MuiInputLabel-root": { color: "#868B8F" },
          "& .MuiInputBase-input": { color: "#FFFFFF" },
          "& .MuiOutlinedInput-root": {
            "& fieldset": { borderColor: "#868B8F" },
            "&:hover fieldset": { borderColor: "#868B8F" },
            "&.Mui-focused fieldset": { borderColor: "#ffffff" },
            "& .MuiSvgIcon-root": {
              color: "#FFFFFF",
            },
            "&.Mui-disabled fieldset": { borderColor: "#868B8F" },
          },
          "& input:-webkit-autofill, \
          & input:-webkit-autofill:hover, \
          & input:-webkit-autofill:focus, \
          & input:-webkit-autofill:active": {
            WebkitBoxShadow: "0 0 0 100px transparent inset !important",
            WebkitTextFillColor: "#FFFFFF !important",
            caretColor: "#FFFFFF",
            transition: "background-color 9999s ease-out, color 9999s ease-out",
          },
        },
      },
    },
  };
}
